export function withExceptionCapturing<T>(handler: (event: React.SyntheticEvent) => Promise<T>) {
  return (event: React.SyntheticEvent) => {
    if (handler) {
      handler(event).catch(error => {
        console.error('Unexpected error', error)
      })
    }
  }
}
